module.exports = __webpack_public_path__ + "static/media/track-mondscheinsonate-adagio-sostenuto.f9c7ac9e.png";